import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgDownload = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="M5.336 0h5.326v5.325h3.995L8 11.983 1.343 5.325h3.993ZM1.568 16v-3h12.864v3Z" /></svg>;
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;